

























import { Component, PropSync, Vue } from 'vue-property-decorator';
import InformationRow from '@/components/display/information-row.vue';
import { User, UsersApi } from '@/api';
import Toast from '@/components/display/toast.vue';
import { ApiUtils } from '@/common/ApiUtils';

@Component({
	components: {
		InformationRow,
	},
	mixins: [],
})
export default class PreferencesComponent extends Vue {
	private readonly api = new UsersApi();
	private readonly toast = new Toast();

	@PropSync('user')
	public localUser?: User;

	public saving: boolean = false;

	public countryOptions: { text: string; value: string }[] = [
		{ text: 'New Zealand', value: 'nz' },
		{ text: 'Australia', value: 'au' },
		{ text: 'Ireland', value: 'ie' },
		{ text: 'United Kingdom', value: 'gb' },
	];

	public languageOptions: { text: string; value: string }[] = [{ text: 'English', value: 'en' }];

	mounted() {
		if (this.localUser && !this.localUser.preferences)
			this.localUser.preferences = {
				country: null,
				language: null,
			};
	}

	public async savePreferences(): Promise<void> {
		if (!this.localUser?.id) return;
		this.saving = true;
		try {
			const response = await this.api.updateUser(this.localUser.id, {
				data: {
					...this.localUser,
					preferences: this.localUser.preferences,
				},
			});
			this.localUser = <User>(<unknown>response.data);
		} catch (ex) {
			const error = ApiUtils.handleApiError(ex, 'Error updating user preferences');
			this.toast.makeToast(error.errorMessage, 'Error', 'danger');
			this.saving = false;
			return;
		}
		this.toast.makeToast('Successfully updated user preferences', 'Success', 'success');
		this.saving = false;
	}
}
